var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.16602H2C1.72667 5.16602 1.5 4.93935 1.5 4.66602C1.5 4.39268 1.72667 4.16602 2 4.16602H14C14.2733 4.16602 14.5 4.39268 14.5 4.66602C14.5 4.93935 14.2733 5.16602 14 5.16602Z",
    fill: "#00092E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5H4C3.72667 8.5 3.5 8.27333 3.5 8C3.5 7.72667 3.72667 7.5 4 7.5H12C12.2733 7.5 12.5 7.72667 12.5 8C12.5 8.27333 12.2733 8.5 12 8.5Z",
    fill: "#00092E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 11.834H6.6665C6.39317 11.834 6.1665 11.6073 6.1665 11.334C6.1665 11.0607 6.39317 10.834 6.6665 10.834H9.33317C9.6065 10.834 9.83317 11.0607 9.83317 11.334C9.83317 11.6073 9.6065 11.834 9.33317 11.834Z",
    fill: "#00092E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.4e744a18ebc1cb72ab92a978e194a312.svg";
export { ForwardRef as ReactComponent };